import { render, staticRenderFns } from "./MSwitch.vue?vue&type=template&id=8f7793c0&scoped=true&"
import script from "./MSwitch.vue?vue&type=script&lang=js&"
export * from "./MSwitch.vue?vue&type=script&lang=js&"
import style0 from "./MSwitch.vue?vue&type=style&index=0&id=8f7793c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7793c0",
  null
  
)

export default component.exports